webpackJsonp([11],{

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _path2 = __webpack_require__(184);

var _path3 = _interopRequireDefault(_path2);

var _importCss2 = __webpack_require__(186);

var _importCss3 = _interopRequireDefault(_importCss2);

var _universalImport2 = __webpack_require__(187);

var _universalImport3 = _interopRequireDefault(_universalImport2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactUniversalComponent = __webpack_require__(67);

var _reactUniversalComponent2 = _interopRequireDefault(_reactUniversalComponent);

var _reactStatic = __webpack_require__(52);

var _p_threeClean = __webpack_require__(972);

var _p_threeClean2 = _interopRequireDefault(_p_threeClean);

var _reactLocalizeRedux = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceWrapper = (0, _reactUniversalComponent2.default)((0, _universalImport3.default)({
  id: "./wrapper.js",
  file: "/opt/build/repo/src/containers/Services/c.js",
  load: function load() {
    return Promise.all([__webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 534)), (0, _importCss3.default)("wrapper", {
      disableWarnings: true
    })]).then(function (proms) {
      return proms[0];
    });
  },
  path: function path() {
    return _path3.default.join(__dirname, "./wrapper.js");
  },
  resolve: function resolve() {
    return /*require.resolve*/(534);
  },
  chunkName: function chunkName() {
    return "wrapper";
  }
}), {
  loading: function loading() {
    return null;
  }
});
ServiceWrapper.preload();

exports.default = function () {
  return _react2.default.createElement(
    ServiceWrapper,
    null,
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement(
        "title",
        null,
        "Investiv Group | Non Sevices - Gestion intelligente d\u2019exploitation agricole"
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "xs-12 content" },
      _react2.default.createElement(
        "div",
        { className: "xs-10 xs-off-1 sm-8 sm-off-2" },
        _react2.default.createElement(
          "h3",
          null,
          _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.three.heading" })
        ),
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.three.paragraph_one" })
        ),
        _react2.default.createElement(
          "div",
          { className: "xs-12 t-c" },
          _react2.default.createElement("img", { src: _p_threeClean2.default, className: "fit" })
        ),
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.four.paragraph_two" })
        )
      )
    )
  );
};
/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/p_three.clean.02d722c8.jpeg";

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Services/c.aaee2210.js